import React from 'react';

export const ProductCartCounter: React.FC = () => {
    return <div className="skeleton skeleton--ssr skeleton--lg"></div>;
};
